import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import fieldTypes from '../../../../../../enums/FieldTypes';
import maxLatinChars from '../../../../../form/field-validation/maxLatinChars';
import stripCharacters from '../../../../../utils/strip-characters';
import PredictionsByField from '../../PredictionsByField';
import {sixDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import validateAutocompleteField from '../../validateAutocompleteField';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import postCode from '../../defaultFieldDefinitions/PostCode';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import * as chineseCharsWhenTaxable from '../../validationByCountry/China/chinese-characters-validators';

const provinces = PredictionsByField.county('CN');
const cities = PredictionsByField.city('CN');

const FieldDefinitionCNWithLoqate = [
  {
    ...addressee,
    validate: [required.fullName, max.lengthAddressee(35), chineseCharsWhenTaxable.fullName],
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.fullName],
  },
  {
    ...companyName,
    validate: [max.lengthCompany(35), chineseCharsWhenTaxable.basic],
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.basic],
  },
  {
    name: 'county', // province
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: provinces,
    validate: [required.county, max.lengthAddress(35), validateAutocompleteField(provinces, 'county')],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
  },
  {
    name: 'townCity', // city
    label: 'checkout.delivery.address.field.label.town.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.town.autoComplete',
    predictions: cities,
    validate: [required.townCity, max.lengthAddress(35), validateAutocompleteField(cities, 'townCity')],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
  },
  {
    name: 'streetName', // district
    label: 'checkout.delivery.address.field.label.district.text',
    required: true,
    validate: [required.address1, max.lengthAddress(35), chineseCharsWhenTaxable.address1],
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.address1],
  },
  {
    ...addressLine2, // house name/number, streetname and additional information
    label: 'checkout.delivery.address.field.label.houseNameNumber.with.streetName.text',
    required: true,
    validate: [required.address2, max.lengthAddress(35), maxLatinChars('address2', 5), chineseCharsWhenTaxable.address2],
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.address2],
  },
  {
    ...postCode,
    fixedLength: 6,
    required: true,
    validate: [required.postCode, max.lengthPostCode(6), sixDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
    excludeFromAddressLookup: ExcludeFromLookup.AFTER,
  },
];

export default FieldDefinitionCNWithLoqate;
